import React from 'react';
import PropTypes from 'prop-types';

import GenericPopup from '../../../../PopUps/GenericPopup';
import { RESUME_POWER_POPUP_COPY } from '../../targetCollegeList';

const TargetCollegePopups = ({
    'data-testid': dataTestId,
    alertCooldownMessage,
    onCloseAlertCooldown,
    addCollegeError,
    onCloseAddCollegeError,
    showResumePowerPopup,
    onResumePower,
    onCloseResumePower,
}) => (
    <>
        {alertCooldownMessage && (
            <GenericPopup
                variant="cpp"
                title="Alert Already Sent"
                subtitle={alertCooldownMessage}
                buttonText="Okay"
                onButtonClick={onCloseAlertCooldown}
                onRequestClose={onCloseAlertCooldown}
                data-testid={dataTestId && `${dataTestId}.alert-cooldown`}
            />
        )}
        {addCollegeError && (
            <GenericPopup
                variant="cpp"
                title="Couldn't Add College"
                subtitle={addCollegeError}
                buttonText="Okay"
                onButtonClick={onCloseAddCollegeError}
                onRequestClose={onCloseAddCollegeError}
                data-testid={dataTestId && `${dataTestId}.add-college-error`}
            />
        )}
        {showResumePowerPopup && (
            <GenericPopup
                variant="cpp"
                title="Resume Power"
                subtitle={RESUME_POWER_POPUP_COPY}
                buttonText="Resume Power"
                onButtonClick={onResumePower}
                onRequestClose={onCloseResumePower}
                data-testid={dataTestId && `${dataTestId}.resume-power`}
            />
        )}
    </>
);

TargetCollegePopups.defaultProps = {
    'data-testid': null,
    alertCooldownMessage: null,
    addCollegeError: null,
    showResumePowerPopup: false,
};

TargetCollegePopups.propTypes = {
    'data-testid': PropTypes.string,
    alertCooldownMessage: PropTypes.string,
    onCloseAlertCooldown: PropTypes.func.isRequired,
    addCollegeError: PropTypes.string,
    onCloseAddCollegeError: PropTypes.func.isRequired,
    showResumePowerPopup: PropTypes.bool,
    onResumePower: PropTypes.func.isRequired,
    onCloseResumePower: PropTypes.func.isRequired,
};

export default TargetCollegePopups;
